import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IEvacuationRoute } from '../models/evacuationRoute';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class EvacuationRouteService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getEvacuationRoutes(buildingId: string, routeType: string): Observable<{has_error: boolean, message: string, data: IEvacuationRoute[]}> {
        const url = environment.apiBaseUrl + endpoints.getEvacuationRoutes
            .replace(':buildingId', buildingId)
            .replace(':routeType', routeType);
        return this.http.get<{has_error: boolean, message: string, data: IEvacuationRoute[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createEvacuationRoute(buildingId: string, routeType: string, data: Partial<IEvacuationRoute>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createEvacuationRoute
            .replace(':buildingId', buildingId)
            .replace(':routeType', routeType);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateEvacuationRoute(buildingId: string, itemId: string, data: Partial<IEvacuationRoute>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateEvacuationRoute
            .replace(':buildingId', buildingId)
            .replace(':itemId', itemId);
        return this.http.put<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteEvacuationRoute(buildingId: string, itemId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteEvacuationRoute
            .replace(':buildingId', buildingId)
            .replace(':itemId', itemId);
        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
